/* unplugin-vue-components disabled */import { render } from "./tenant-af.vue?vue&type=template&id=5716f6f4&scoped=true"
import script from "./tenant-af.vue?vue&type=script&lang=js"
export * from "./tenant-af.vue?vue&type=script&lang=js"

import "./tenant-af.vue?vue&type=style&index=0&id=5716f6f4&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5716f6f4"],['__file',"src/pages/tenants/settings/tenant-af.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5716f6f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5716f6f4', __exports__)) {
    api.reload('5716f6f4', __exports__)
  }
  
  module.hot.accept("./tenant-af.vue?vue&type=template&id=5716f6f4&scoped=true", () => {
    api.rerender('5716f6f4', render)
  })

}


export default __exports__